/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { currencies } from '../../../utilities/constants';
import { formatNumber } from '../../../utilities/formatHelpers';
import { dynamicAssets } from '../../../utilities/helpers';

const CurrencyCard = ({ data, mainScreen, chooseWallet, openScreen, wallets }) => {
  const wallet = wallets.find((w) => w.coin === data.currency_code);

  const balance = formatNumber(
    (wallet?.available_balance || 0) * currencies[data.currency_code.toUpperCase()].conversion,
    currencies[data.currency_code.toUpperCase()].decimal
  );

  const handleSelectWallet = () => {
    chooseWallet(data);
    openScreen(mainScreen);
  };

  return (
    <div
      role="button"
      key={data.currency_code.toUpperCase()}
      tabIndex="0"
      className="bg-light rounded-extra p-3 d-flex flex-row mt-2 hover-container"
      onClick={handleSelectWallet}
      onKeyDown={handleSelectWallet}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <img
          className="me-2"
          style={{
            width: '1.5rem',
            height: '1.5rem',
            ...(data.currency_code?.toUpperCase() === currencies.XRP.icon
              ? {
                  backgroundColor: 'white',
                  padding: '1px',
                  borderRadius: '20px',
                }
              : {}),
          }}
          alt={data.currency_code.toUpperCase()}
          src={dynamicAssets(`./assets/icons/${data.currency_code.toUpperCase()}.svg`)}
        />
        <div className="d-flex flex-column">
          <b>{data.currency_code.toUpperCase()}</b>
          <p className="text-shadow text-f6 m-0">
            {`${balance} ${data.currency_code.toUpperCase()}`}
          </p>
        </div>
      </div>
      <div className="d-flex justify-content-end align-items-center flex-fill">
        <i className="icon icon-arrow-next-navigation text-primary" />
      </div>
    </div>
  );
};

export default CurrencyCard;

CurrencyCard.propTypes = {
  data: PropTypes.object.isRequired,
  openScreen: PropTypes.func.isRequired,
  chooseWallet: PropTypes.func.isRequired,
  mainScreen: PropTypes.string.isRequired,
  wallets: PropTypes.array.isRequired,
};
